import { Badge, BadgeContainer } from '@progress/kendo-react-indicators'
import { nanoid } from 'nanoid'
import React from 'react'
export const ToolButton = (props: ToolButtonProps) => {
    return (
        <div key={nanoid()}>
            {props.badge
                ?
                <div key={nanoid()} title={props.title}>
                    <BadgeContainer >
                        <button title={props.title} className={`tool-button ${props.class} ${props.selected ? '' : 'tool-button-disabled'}`} onClick={() => props.onClick(props.id)}><img src={props.imageUrl}></img></button>

                        <Badge rounded='medium' className='mr-3 mt-3' size='small' align={{ horizontal: "end", vertical: "top" }}>{props.badge}</Badge>
                    </BadgeContainer>
                </div>
                :
                <button key={nanoid()} title={props.title} className={`tool-button ${props.class} ${props.selected ? '' : 'tool-button-disabled'}`} onClick={() => props.onClick(props.id)}><img src={props.imageUrl}></img></button>

            }


        </div>
    )
}

export type ToolButtonProps = {
    id: string
    imageUrl: string
    onClick: (id) => void
    class?: string
    title: string
    selected: boolean
    badge?: string | JSX.Element
}  